import { JourneyPassenger } from './journey-passenger';
import { Bus } from './bus';

export class Journey {
  id: number;
  name: string;
  busId: number;
  Bus: Bus;
  day: number;
  J_1: boolean;
  J_2: boolean;
  J_3: boolean;
  J_4: boolean;
  J_5: boolean;
  type: string;
  start: any;
  end: any;
  waitTimePassager: number;
  distance: number;
  startPositionLat: string;
  startPositionLng: string;
  endPositionLat: string;
  endPositionLng: string;
  JourneyPassengers: any[]; // JourneyPassenger[];

  constructor() {
  }
}




// WEBPACK FOOTER //
// ./src/app/models/journey.ts